<template>
    <div class="modal modal-bg" :class="{ show: open }">
        <modal v-if="open" modal-with-card card-classes="md-card-login" type="modal-signup" @close="closeModal" >
            <template #header>
                <md-card-header class="md-card-header-cyan m-0">
                    <md-button class="md-simple md-close md-white md-just-icon md-round modal-card-button mt-10" @click="closeModal" >
                        <md-icon class="opacity-100">{{ $t("icon.clear") }}</md-icon>
                    </md-button>
                    <h4 class="card-title mt-0">Notifications</h4>
                </md-card-header>
            </template>

            <template #body>
                <div class="notifications-modal-container mt-15">
                    <div class="over notification-table-header md-layout">
                        <div class="md-layout-item md-size-35 md-xsmall-size-100">
                            <div class="notification-select-all">
                                <md-checkbox class="pl-5" v-model="allSelected" @change="selectAll" :style="isMobile ? 'margin-top: 8px;' : '' " />
                            </div>
                            <div class="notification-all-actions">
                                <md-button class="md-just-icon my-0 md-cyan-900 md-simple md-lg m-0"  @click="refreshNotifications" :disabled="isDisabledBtns">
                                    <md-icon>{{ $t("icon.refresh") }}</md-icon>
                                    <md-tooltip md-direction="top">Refresh</md-tooltip>
                                </md-button>
                                <md-button class="md-just-icon my-0 md-cyan-900 md-simple md-lg m-0" id="deleteNotifications" v-show="selectedNotifications.length > 0"
                                           @click="deleteNotifications" :disabled="isDisabledBtns">
                                    <md-icon>{{ $t("icon.trash") }}</md-icon>
                                    <md-tooltip md-direction="top">Delete notification(s)</md-tooltip>
                                </md-button>
                                <md-button class="md-just-icon my-0 md-cyan-900 md-simple md-lg m-0" id="markAsRead" :disabled="isDisabledBtns" @click="markAsReadMultiply"
                                           v-show="selectedNotifications.length > 0 && isUnreadedInSelectedRows">
                                    <md-icon class="material-icons-outlined">{{$t("icon.drafts")}}</md-icon>
                                    <md-tooltip md-direction="top">Mark as read</md-tooltip>
                                </md-button>
                                <md-button class="md-just-icon md-cyan-900 md-simple md-lg m-0" id="markAsUnread" @click="markAsUnReadMultiply" :disabled="isDisabledBtns"
                                           v-show="selectedNotifications.length > 0 && !isUnreadedInSelectedRows">
                                    <md-icon class="material-icons-outlined"> {{ $t("icon.unread") }} </md-icon>
                                    <md-tooltip md-direction="top">Mark as unread</md-tooltip>
                                </md-button>
                            </div>
                        </div>
                        <div class="md-layout-item md-size-65 md-xsmall-size-100">
                            <md-field class="pt-0">
                                <InputText type="text" class="p-column-filter w-90" v-model="filterModel.searchValue" placeholder="Enter text to search"
                                           @keyup.enter="onSearchValueChange" @blur="onSearchValueChange" />
                                <span @click="onSearchValueChange">
                                        <md-icon class="h-100 hover-cyan-900">search</md-icon>
                                    </span>
                                <div class="md-icon" @click="clearSearchValue();" v-if="filterModel.searchValue">
                                    <md-icon>clear</md-icon>
                                </div>
                            </md-field>
                        </div>
                    </div>

                    <div class="over" v-show="notifications && notifications.length > 0">
                        <table class="table-fixed" ref="notification-table">
                            <tbody>
                            <tr v-for="item in notifications" :key="item.userLogId" :class="item.display == LogMarker.read ? 'fw-400' : 'fw-bold'" v-show="item.display != null">
                                <td style="width: 5%" class="text-end">
                                    <md-checkbox v-model="item.selected" @change="onSelect(item)" />
                                </td>
                                <td style="width: 60%">
                                    <div v-html="item.message" :class="{ 'message-clamped': !item.expanded }" :ref="'msg_' + item.userLogId"></div>
                                    <a v-if="item.hasOverflow && !item.expanded" @click="item.expanded = true" class="dev-link pointer">Show More</a>
                                    <a v-else-if="item.hasOverflow && item.expanded" @click="item.expanded = false" class="dev-link pointer">Show Less</a>
                                    <div v-if="item.linkText && item.linkClickMethod">
                                        <a @click="notificationLinkClick(item.linkClickMethod)" class="dev-link pointer">{{item.linkText}}</a>
                                    </div>
                                </td>
                                <td style="width: 20%">{{item.dateTime}}</td>
                                <td style="width: 15%" class="notification-actions text-center">
                                    <md-button class="md-just-icon md-cyan-900 md-simple md-sm m-0" @click="deleteNotification(item)">
                                        <md-icon>{{ $t("icon.trash") }}</md-icon>
                                        <md-tooltip md-direction="top">Delete</md-tooltip>
                                    </md-button>
                                    <md-button v-if="item.display == LogMarker.unread" class="md-just-icon md-cyan-900 md-simple md-sm m-0" @click="markAsRead(item)">
                                        <md-icon class="material-icons-outlined">{{ $t("icon.drafts") }}</md-icon>
                                        <md-tooltip md-direction="top">Mark as read</md-tooltip>
                                    </md-button>
                                    <md-button v-if="item.display == LogMarker.read" class="md-just-icon md-cyan-900 md-simple md-sm m-0" @click="markAsUnRead(item)">
                                        <md-icon class="material-icons-outlined">{{ $t("icon.unread") }}</md-icon>
                                        <md-tooltip md-direction="top">Mark as unread</md-tooltip>
                                    </md-button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="md-layout mt-10">
                            <Paginator class="mx-auto" :rows="filterModel.limitCount" :totalRecords="notificationsCount" :rowsPerPageOptions="[50, 100, 500]"
                                       :pageLinkSize="3" @page="handlePaginationChange($event)"></Paginator>

                        </div>
                    </div>
                    <div v-if="!notifications || notifications.length == 0">
                        <md-empty-state>
                            <h5>No notification found</h5>
                        </md-empty-state>
                    </div>
                </div>
            </template>

            <template slot="footer"></template>
        </modal>
    </div>
</template>

<script>
import Modal from "@/components/Modal.vue";
import ApiUsersLogs from "@/api/methods/ApiUsersLogs";
import {VTooltip} from "v-tooltip";
import UsersLogModel from "@/api/models/user/UsersLogModel";
import {Collection} from "vue-mc";
import Mixins from "@/plugins/basicMixins";
import {ErrorHelper} from "@/api/helpers";
import {REDIRECT_LINKS, ROUTER_LINKS} from "@/plugins/Constants";
import {OffersPaths} from "@/router/const/OffersPaths";
import {Pagination} from "@/components";

export const LogMarker = Object.freeze({
    delete: null,
    read: "read",
    unread: "unread",
});

export default {
    name: "ModalNotification",
    components: {Modal},
    mixins: [Mixins.ShowToastr, Mixins.Loading, Mixins.SetPath, Mixins.DetectMobile],
    props: {
        open: Boolean,
    },
    watch: {
        open: {
            immediate: true,
            handler(value) {
                if (value == true) {
                    this.enableButtons();
                    this.getLogs(true);
                }
            },
        },
    },
    data() {
        return {
            LogMarker: LogMarker,
            disableBtn: false,
            tableMarginTop: [window.innerWidth <= 576 ? "mt-0" : ""],
            notifications: [],
            allSelected: false,
            notificationsCount: 0,
            curPage: 1,
            filterModel: {
                searchValue: "",
                limitStart: 0,
                limitCount: 50,
            },
            previousSearchValue: "",
            selectedNotifications: []
        };
    },
    computed: {
        isDisabledBtns() {
            return this.disableBtn;
        },
        isUnreadedInSelectedRows() {
            return this.selectedNotifications.some((item) => item.selected && item.display == LogMarker.unread);
        },
    },
    methods: {
        getLogs(needToClearSelection) {
            this.showLoading();
            let token = sessionStorage.getItem("token");
            if (!token) {
                this.closeModal();
                return;
            }
            this.filterModel.limitStart = (this.curPage - 1) * this.filterModel.limitCount;
            ApiUsersLogs.getDisplayedUserLogs(this.filterModel)
                .then((response) => {
                    if (needToClearSelection) {
                        this.selectedNotifications = [];
                        this.notifications = response.data.notificationsList.map(item => ({
                            ...item,
                            selected: false,
                            expanded: false,
                            hasOverflow: false,
                        }));
                        this.notificationsCount = response.data.notificationsCount;
                    } else {
                        this.notifications = response.data.notificationsList.map(notification => {
                            notification.selected = this.selectedNotifications.some(n => n.userLogId === notification.userLogId);
                            notification.expanded = false;
                            notification.hasOverflow = false;
                            return notification;
                        });
                        this.allSelected = this.notifications.every(function(n) {
                            return n.selected;
                        })
                    }
                    this.hideLoading();
                    this.$nextTick(() => this.checkOverflow());
                })
                .catch((e) => {
                    console.error(e);
                    this.hideLoading();
                    this.enableButtons();
                    this.closeModal();
                    let msg = ErrorHelper.message(e, null);
                    if (msg) {
                        this.showError(this.name, msg);
                    }
                });
        },
        handlePaginationChange(){
            this.getLogs(false);
            this.$nextTick(() => {
                const container = this.$refs[("notification-table")];
                if (container) {
                    container.scrollTop = 0;
                }
            });
        },
        onSearchValueChange(){
            if (this.filterModel.searchValue != this.previousSearchValue) {
                this.curPage = 1;
                this.previousSearchValue = this.filterModel.searchValue;
                this.getLogs(true);
            }
        },
        clearSearchValue() {
            this.filterModel.searchValue = "";
            this.onSearchValueChange();
        },
        closeModal() {
            this.$emit("close");
        },
        selectAll() {
            this.notifications.forEach((item) => {
                item.selected = this.allSelected;
                if (this.allSelected) {
                    this.selectedNotifications.push(item);
                } else {
                    var index = this.selectedNotifications.findIndex(n => n.userLogId === item.userLogId);
                    if (index > -1) {
                        this.selectedNotifications.splice(index, 1);
                    }
                }
            });
        },
        onSelect(item) {
            this.allSelected = this.notifications.every((item) => item.selected);
            if (item.selected) {
                this.selectedNotifications.push(item);
            } else {
                var index = this.selectedNotifications.findIndex(n => n.userLogId === item.userLogId);
                if (index > -1) {
                    this.selectedNotifications.splice(index, 1);
                }
            }
        },
        deleteNotification(item) {
            item.display = null;
            this.save();
        },
        markAsRead(item) {
            item.display = LogMarker.read;
            this.save();
        },
        markAsUnRead(item) {
            item.display = LogMarker.unread;
            this.save();
        },
        refreshNotifications() {
            this.getLogs(true);
        },
        disableButtons() {
            this.disableBtn = true;
        },
        enableButtons() {
            this.disableBtn = false;
        },
        save() {
            let token = sessionStorage.getItem("token");
            if (token) {
            } else {
                this.closeModal();
                return;
            }
            if (this.selectedNotifications.count <= 0) {
                return;
            }
            this.disableButtons();

            ApiUsersLogs.markUserLogs(
                token,
                this.selectedNotifications.map(function (item) {
                    if (item.display == "null" || item.display == LogMarker.delete) {
                        return {
                            display: null,
                            userLogId: item.userLogId,
                        };
                    }
                    return {
                        display: item.display,
                        userLogId: item.userLogId,
                    };
                })
            )
                .then((_) => {
                    this.enableButtons();
                    this.getLogs(true);
                })
                .catch((e) => {
                    this.enableButtons();
                    let msg = ErrorHelper.message(e, null);
                    if (msg) {
                        this.showError(this.name, msg);
                    }
                });
        },
        deleteNotifications() {
            this.notifications.forEach((model) => {
                if (model.selected) {
                    model.display = LogMarker.delete;
                }
            });
            this.save();
        },
        markAsReadMultiply() {
            this.selectedNotifications.forEach((model) => {
                if (model.selected) {
                    model.display = LogMarker.read;
                }
            });
            this.save();
        },
        markAsUnReadMultiply() {
            this.selectedNotifications.forEach((model) => {
                if (model.selected) {
                    model.display = LogMarker.unread;
                }
            });
            this.save();
        },
        checkOverflow() {
            this.notifications.forEach(item => {
                const el = this.$refs['msg_' + item.userLogId];
                const node = Array.isArray(el) ? el[0] : el;
                if (node) {
                    this.$set(item, 'hasOverflow', node.scrollHeight > node.clientHeight);
                }
            });
        },
        notificationLinkClick(linkClickMethod){
            if (linkClickMethod && typeof this[linkClickMethod] === "function") {
                this[linkClickMethod]();
            }
        },
        /* important: do not delete! method called by name */
        viewOffersBuyerLinkClick(){
            this.closeModal();
            this.$router.push(OffersPaths.buyerOffers.path).catch(err => {this.$router.go(); });
        },
        /* important: do not delete! method called by name */
        viewOffersSellerLinkClick(){
            this.closeModal();
            this.$router.push(OffersPaths.sellerOffers.path).catch(err => {this.$router.go(); });
        },
        /* important: do not delete! method called by name */
        viewSharedNotesClick(){
            this.closeModal();
            var redirectUrl = this.setPath();
            if (redirectUrl) {
                window.location.href = redirectUrl + REDIRECT_LINKS.request + "mode=sharedNotes";
            }
        },
        /* important: do not delete! method called by name */
        changeMainScreenLinkClick(){
            this.closeModal();
            this.$router.push(ROUTER_LINKS.mainScreen.path).catch(err => {this.$router.go(); });
        }
    },
    mounted() {
        VTooltip.options.autoHide = false;
    },
};
</script>
